module.exports = "<h1 mat-dialog-title>{{'CART.NOTIFICATION.LC_TITLE'|translate}}</h1>\r\n<div mat-dialog-content>\r\n    <mat-progress-bar\r\n            color=\"primary\"\r\n            mode=\"indeterminate\">\r\n    </mat-progress-bar>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/cart-notification/cart-notification.component.html
// module id = ./src/app/components/cart-notification/cart-notification.component.html
// module chunks = main